import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Liste des films")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Ajouter un film")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Mon CV")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_router_link, { to: "/add" }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _hoisted_5,
    _createVNode(_component_router_link, { to: "/cv" }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}